import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Cookies } from '../../index.js';
import Post_content from '../../community/content/Blog_posts.jsx';
import { alert_error, alert_success } from '../../AppContext';

const MoviePlayer = () => {
    const [movie, setMovie] = useState(null);
    const [currentLink, setCurrentLink] = useState(""); // Link server hiện tại
    const { filmId } = useParams();
    const myCookieValue = Cookies.get('apikey');
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        if (status == 0) {
            alert_error(info.message);
        }

        else if (status == 1) {
            alert_success(info.message);
            const movieData = info.data.movie;
            setMovie(movieData);
            if (movieData.episodes?.length > 0) {
                setCurrentLink(movieData.episodes[0].server_data[0].link);
            }
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        axios
            .get("https://hust.media/giai-tri/visual/play_test.php", {
                params: { apikey: myCookieValue, slug_2: filmId },
            })
            .then(response => {
                testFunction(response);
            })
            .catch(error => console.error("Lỗi tải phim:", error));
    }, [filmId]);

    return (
        <div className="max-w-3xl mx-auto p-4">
            {movie ? (
                <>
                    {
                        myCookieValue ?
                            (<>
                                <div className="bg-white rounded-lg shadow-lg p-4">
                                    <img
                                        src={movie.thumb_url}
                                        alt={movie.name}
                                        className="rounded-lg w-full h-60 object-cover"
                                    />
                                    <h2 className="text-2xl font-semibold mt-2">{movie.name}</h2>
                                    <p className="text-gray-500">{movie.time} - {movie.quality}</p>
                                    <p dangerouslySetInnerHTML={{ __html: movie.content }} className="mt-2"></p>
                                    {/* Chọn Server */}
                                    <div className="mt-4">
                                        <h3 className="text-lg font-semibold">Chọn Server</h3>
                                        <div className="flex flex-wrap gap-2">
                                            {movie.episodes?.map((ep, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setCurrentLink(ep.server_data[0].link)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded-md"
                                                >
                                                    {ep.server_name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Video Player */}
                                    <div className="mt-4">
                                        {currentLink ? (
                                            <iframe
                                                src={currentLink}
                                                className="w-full h-80 rounded-lg border"
                                                allowFullScreen
                                            ></iframe>
                                        ) : (
                                            <p className="text-red-500">Chưa có link video!</p>
                                        )}
                                    </div>
                                </div>
                            </>) :
                            (<>
                                <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'29'} />
                            </>)
                    }
                </>
            ) : (
                <p>Đang tải...</p>
            )}
        </div>
    );
};

export default MoviePlayer;